import client from '@lib/core/axios.client';
import { API_ENDPOINTS } from '@lib/constants';
import type {
  AdminSupportTicketDto,
  AdminSupportTicketListParams,
  AdminSupportTicketListResponse,
  CreateAdminSupportTicketMessageRequest,
  UpdateAdminSupportTicketStatusRequest,
} from '@/types/api/admin';

export class AdminSupportTicketService {
  private static instance: AdminSupportTicketService;

  private constructor() {}

  public static getInstance(): AdminSupportTicketService {
    if (!AdminSupportTicketService.instance) {
      AdminSupportTicketService.instance = new AdminSupportTicketService();
    }
    return AdminSupportTicketService.instance;
  }

  async getTickets(params?: AdminSupportTicketListParams): Promise<AdminSupportTicketListResponse> {
    return await client.get<AdminSupportTicketListResponse>(
      API_ENDPOINTS.ADMIN.SUPPORT.TICKETS,
      { params }
    );
  }

  async getTicket(ticketId: string): Promise<AdminSupportTicketDto> {
    return await client.get<AdminSupportTicketDto>(
      API_ENDPOINTS.ADMIN.SUPPORT.TICKET_BY_ID(ticketId)
    );
  }

  async updateStatus(ticketId: string, data: UpdateAdminSupportTicketStatusRequest): Promise<void> {
    await client.put<void>(
      API_ENDPOINTS.ADMIN.SUPPORT.TICKET_STATUS(ticketId),
      data
    );
  }

  async createMessage(ticketId: string, data: CreateAdminSupportTicketMessageRequest): Promise<void> {
    await client.post<void>(
      API_ENDPOINTS.ADMIN.SUPPORT.TICKET_MESSAGES(ticketId),
      data
    );
  }
}

export const adminSupportTicketService = AdminSupportTicketService.getInstance();
export default adminSupportTicketService;
